import { Metadata } from '@tencent/workbench-core';
import { InjectorService } from '@tencent/ioc';
import { WORKBENCH_SETTINGS } from '../../constants/metadata-keys.js';

/**
 * Workbench 设置装饰器
 *
 * @public
 * @param settings - Workbench 启动设置
 */
function WorkbenchSettings(settings) {
    return (target) => {
        Metadata.set(WORKBENCH_SETTINGS, settings, target);
        InjectorService.set(target);
    };
}

export { WorkbenchSettings };
//# sourceMappingURL=workbench-settings.js.map
